<template>
	<div>
		<div class="flex items-center justify-center">
			<div class="bg-background rounded-full p-1 w-8 text-center mr-1">
				<app-icon v-if="status.active" icon="save" class="bg-background rounded-full p-1" />
				<span v-else>{{ index }}</span>
			</div>
			<div class="relative">
				<div class="font-bold">{{ status.label }}</div>
				<span v-if="getDuration" class="delayInfo badge">{{ getDuration }}</span>
			</div>
		</div>
		<div class="time" v-if="status.time">{{ $filters.getTime(status.time) }}</div>
		<div class="time" v-else>{{ '-- : --' }}</div>
	</div>
</template>

<script>
	import UtilityService from '@/services/UtilityService';
	import AppIcon from '@/components/app/AppIcon';

	export default {
		name: 'orderDetailsStatus',
		components: { AppIcon },
		props: {
			status: {
				type: Object,
				required: true,
			},
			duration: {},
			index: {},
		},
		computed: {
			getDuration() {
				return parseInt(this.duration) > 0 ? `+${this.duration}` : '';
			},
		},
		methods: {
			getTime(val) {
				return UtilityService.getTime(val);
			},
		},
	};
</script>

<style scoped>
	.status-number {
		padding: 2px 8px;
		background-color: #e5e5e5;
		color: #19be6b;
		border-radius: 50%;
	}

	.delayInfo {
		@apply absolute bg-secondary;
		top: -8px;
		right: -18px;
	}

	.time {
		text-align: center;
		font-size: 13px;
	}

	.active-status-icon {
		max-height: 26px;
	}
</style>
